import { useQuery } from "@tanstack/react-query";
import { getItemsFromCollection } from "directus/src/operations";

/**
 * Hook to check if feedback tabs should be visible for the current user
 * Currently returns true only if there are any performance review entries where
 * the current user is employee but not reviewee (given feedbacks).
 */
export const useFeedbackVisibility = (quadId) => {
  const {
    data: feedbackData = { hasGivenFeedbacks: false },
    isLoading,
    error,
  } = useQuery({
    queryKey: ["feedback-visibility", quadId, "given"],
    queryFn: async () => {
      if (!quadId) return { hasGivenFeedbacks: false };

      try {
        // Check for given feedbacks (current user is employee but not reviewee)
        const givenQuery = {
          fields: ["id"],
          filter: {
            quadrimester: { _eq: quadId },
            reviewee: { user: { _neq: "$CURRENT_USER" } },
            reviewer: { user: { _eq: "$CURRENT_USER" } },
          },
          limit: 1, // We only need to know if any exist
        };

        const givenResponse = await getItemsFromCollection(
          "performance_review",
          givenQuery,
        );

        return { hasGivenFeedbacks: givenResponse?.length > 0 };
      } catch (error) {
        console.error("Error checking feedback visibility:", error);
        return { hasGivenFeedbacks: false };
      }
    },
    enabled: !!quadId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return {
    hasGivenFeedbacks: feedbackData.hasGivenFeedbacks,
    isLoading,
    error,
  };
};
